<template>
    <div class="page-grid w-full grow content-center gap-y-10">
        <div class="col-span-full md:col-span-7">
            <h1 class="text-display">Error<br>Platform</h1>
        </div>

        <div class="col-span-full md:col-span-4 md:col-start-9 self-end">
            <YCard title="Log in">
                <p class="text-ink-muted mb-6">Sign in with your Yipp Slack account.</p>
                <p v-if="errorMessage" role="alert" class="mb-6 border-l-2 border-danger pl-3 text-danger">{{ errorMessage }}</p>
                <YButton :href="loginHref" variant="secondary" size="lg" class="w-full">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 122.8 122.8" aria-hidden="true">
                        <path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a"/>
                        <path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0"/>
                        <path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d"/>
                        <path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e"/>
                    </svg>
                    Log in with Slack
                </YButton>
            </YCard>
        </div>
    </div>
</template>

<script lang="ts" setup>
const route = useRoute()
const errorMessage = computed(() => {
    const code = route.query.error
    if (typeof code !== 'string') return null
    return LOGIN_ERROR_MESSAGES[code as LoginErrorCode] ?? LOGIN_ERROR_MESSAGES.failed
})
// Brings people back to the page that sent them here, e.g. a pairing link from the desktop app
const loginHref = computed(() => {
    const redirect = safeRedirectPath(route.query.redirect)
    return redirect ? `/api/auth/slack/login?redirect=${ encodeURIComponent(redirect) }` : '/api/auth/slack/login'
})
</script>
